import { useEffect, useState } from 'react'
import { MeetingsDatedQuery, useMeetingsDatedQuery } from '../generated/graphql'

export default function useMeetingsDated(firstRaceFrom: string, to: string) {
  const [meetings, setMeetings] = useState<MeetingsDatedQuery['meetingsDated']>(
    {} as MeetingsDatedQuery['meetingsDated']
  )

  const { data } = useMeetingsDatedQuery({
    fetchPolicy: 'cache-and-network',
    variables: { firstRaceFrom, to },
    pollInterval: 30 * 60 * 1000,
  })

  useEffect(() => {
    setMeetings(data?.meetingsDated || ({} as MeetingsDatedQuery['meetingsDated']))
  }, [data])

  return meetings
}

export type useMeetingsReturnType = ReturnType<typeof useMeetingsDated>
